/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Attr_MemberInputs */



/**
* | output |
* | --- |
* | "Another member" |
*
* @param {Deck_Upload_Attr_MemberInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_attr_member = /** @type {((inputs?: Deck_Upload_Attr_MemberInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Attr_MemberInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un autre membre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Otro miembro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Outro membro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un altro membro")
	return /** @type {LocalizedString} */ ("Another member")
});